<div class="session-verification-container">
  <div class="session-verification-content">
    <div *ngIf="loading" class="loading-section">
      <div class="spinner"></div>
      <h2>Verifying your session</h2>
      <p>Please wait while we authenticate your session...</p>
    </div>

    <div *ngIf="!loading && errorMessage" class="error-section">
      <div class="error-icon">
        <i class="fa fa-exclamation-circle"></i>
      </div>
      <h2>Session verification failed</h2>
      <p>{{ errorMessage }}</p>
    </div>
  </div>
</div>
